<div class="reset_password_container">
  <h1>{{ 'PAGES.RESET_PASSWORD.HEADER' | translate }}</h1>
  <p>{{ 'PAGES.RESET_PASSWORD.PARAGRAPH' | translate }}</p>
  <div class="input" [ngClass]="{ focused: inputFocusClass === 1 }">
    <mat-icon class="notranslate">vpn_key</mat-icon>
    <input
      type="password"
      name="password"
      [(ngModel)]="password"
      [placeholder]="'PLACEHOLDERS.PASSWORD' | translate"
      (focus)="inputFocusClass = 1"
      (blur)="inputFocusClass = 0"
      (input)="setPasswordColor()"
      (keydown)="passwordHasBeenTouchedFunc()"
    />
  </div>
  @if (firstPasswordIsTouched) {
    <div class="pass_hint_div">
      <p class="pass-hint" [style.color]="characterLenghtColor">
        @if (characterLenghtColorCheck) {
          <mat-icon>check</mat-icon>
        } @else {
          <mat-icon>close</mat-icon>
        }

        {{ 'DIALOGS.AUTHENTIFICATION.SIGNUP.CHARACTER_LENGHT' | translate }}
      </p>
      <p class="pass-hint" [style.color]="lowerCharacterColor">
        @if (lowerCharacterColorCheck) {
          <mat-icon>check</mat-icon>
        } @else {
          <mat-icon>close</mat-icon>
        }
        {{ 'DIALOGS.AUTHENTIFICATION.SIGNUP.LOWERCASE_CHARACTER' | translate }}
      </p>
      <p class="pass-hint" [style.color]="upperCharacterColor">
        @if (upperCharacterColorCheck) {
          <mat-icon>check</mat-icon>
        } @else {
          <mat-icon>close</mat-icon>
        }
        {{ 'DIALOGS.AUTHENTIFICATION.SIGNUP.UPPERCASE_CHARACTER' | translate }}
      </p>
      <p class="pass-hint" [style.color]="numberColor">
        @if (numberColorCheck) {
          <mat-icon>check</mat-icon>
        } @else {
          <mat-icon>close</mat-icon>
        }
        {{ 'DIALOGS.AUTHENTIFICATION.SIGNUP.NUMBER' | translate }}
      </p>
    </div>
  }

  <div class="input" [ngClass]="{ focused: inputFocusClass === 2 }">
    <mat-icon class="notranslate">vpn_key</mat-icon>
    <input
      type="password"
      name="confirmPassword"
      [(ngModel)]="confirmPassword"
      [placeholder]="'PLACEHOLDERS.CONFIRM_PASSWORD' | translate"
      (focus)="inputFocusClass = 2"
      (blur)="inputFocusClass = 0"
    />
  </div>
  <button
    class="handyhand_button blue_button"
    [ngClass]="{ disabled: isBtnDisabled() }"
    (click)="reset()"
  >
    {{ 'PAGES.RESET_PASSWORD.RESET' | translate }}
  </button>
</div>
